import React, { useEffect, useState } from 'react';
import { Box, FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup, Typography, IconButton, Grid } from '@material-ui/core';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import { AppSelect } from './InputComponents';
import useStyles from "./CancerDiagnosis.style";
import { sitesOfCancer, cancerTreatments } from '../../../data/db';
import { arrayOfNumbers } from '../../../services/util.service';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import { MobileButton } from '../../../components/MobileButton';
import { AppTextField } from '../components/InputComponents';
import multiItemQuestion from './MultiItemQuestion.component';

const CancerDiagnosis = props => {
    const classes = useStyles();
    const [autoUpdate, setAutoUpdate] = useState(false);
    const currentYear = new Date().getFullYear();
    let cancerYears = [...arrayOfNumbers((new Date(props.dateOfBirth).getFullYear()) + 10, (currentYear - new Date(props.dateOfBirth).getFullYear() - 9))];

    useEffect(() => {
        props.validator.purgeFields();
        setAutoUpdate(!autoUpdate);
    }, [props.items]);

    useEffect(()=>{
        props.items.map((val, i)=>{
            if(val.year===""){
                val.treatments.map((val, j)=>{
                    val.fromYears=[];
                    val.toYears=[];
                })
            }
        })
    },[props.items])

    const handleSitesOfCancerTreatmentChange = (i, siteOfCancer) => {
        if (!(['Other'].includes(siteOfCancer))) {
            props.onChange(i, 'otherSiteOfCancer', '')();
        };
        props.onChange(i, 'siteOfCancer', siteOfCancer)();
    };


    return (
        <Box className={classes.root}>
            {/* Header */}
            <Box><QuestionAnswerIcon className={classes.textIcon} /></Box>
            <Typography variant="h4" className={classes.title}>Please give us information about your cancer diagnosis</Typography>
            {props.error && !props.validator.allValid() &&
                <Typography color="error">
                    Please review your answers
                </Typography>
            }
            {/* Ever been diagnosed as having cancer */}
            <Box className={classes.inputSection}>
                <Typography variant="h5">

                    Have you ever had a cancer  diagnosis?
                    {
                        <span className={props.error && !props.validator.fieldValid('anyCancerDiagnosis') ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                    }
                </Typography>
                <FormControl
                    component="fieldset"
                    error={props.error && !props.validator.fieldValid('anyCancerDiagnosis')}
                >
                    <RadioGroup row
                        aria-label="Cancer Diagnosis"
                        value={props.anyCancerDiagnosis}
                        onChange={props.onCancerDiagnosisChange}
                    >
                        {['Yes', 'No', 'Currently'].map((answer, i) =>
                            <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                        )}
                    </RadioGroup>
                    <FormHelperText>
                        {props.validator.message(`anyCancerDiagnosis`, props.anyCancerDiagnosis, 'required')}
                    </FormHelperText>
                </FormControl>
            </Box>
            {/* Current site of cancer */}
            <Box className={classes.inputSection} display={props.anyCancerDiagnosis === 'Currently' ? 'block' : 'none'}>
                <AppTextField
                    variant="outlined"
                    label="Please describe your current site of cancer"
                    margin="normal"
                    fullWidth
                    inputProps={{ style: { maxLength: 500, textAlign: 'center' } }}
                    value={props.currentSiteOfCancer}
                    onChange={props.onCurrentSiteOfCancerChange}
                    error={props.error && !props.validator.fieldValid(`current_site_of_cancer`)}
                    helperText={props.validator.message(`current_site_of_cancer`, props.currentSiteOfCancer, `describe_current_site_of_cancer:${props.anyCancerDiagnosis}`)}
                />
            </Box>
            {/* Confirmed diagnosis and cancer treatments taken */}
            {(props.anyCancerDiagnosis && (props.anyCancerDiagnosis === 'Yes')) &&
                <>
                    <Typography variant="h5" className={classes.marginStyle}>Please list current and past cancer diagnoses and cancer treatments.</Typography>
                    <>
                        {props.items.map((cancer, i) =>
                            <Box className={classes.item} key={i}>
                                <Box className={classes.itemHeader}>
                                    <span>Cancer #{i + 1}</span>
                                    <IconButton aria-label="delete" color="inherit" onClick={props.onRemove(i)}>
                                        <DeleteIcon />
                                    </IconButton>
                                </Box>
                                {/* Site of cancer diagnosis */}
                                <Box className={classes.itemBody}>
                                    <Typography variant="h5">Tell us about your cancer diagnosis.

                                        {
                                            <span className={((props.error && !props.validator.fieldValid(`cancer_#${i + 1}_site_of_cancer`)) ||
                                                (props.error && !props.validator.fieldValid(`cancer_#${i + 1}_year`))) ? `${classes.asteriskError}` :
                                                `${classes.asteriskNormal}`} >*</span>
                                        }

                                    </Typography>
                                    <>
                                        <Box className={classes.inputSection}>
                                            <AppSelect
                                                id={`cancer${i + 1}`}
                                                label="Primary site of cancer"
                                                value={cancer.siteOfCancer}
                                                items={[...sitesOfCancer, 'Other']}
                                                onChange={e => handleSitesOfCancerTreatmentChange(i, e.target.value)}
                                                fullWidth
                                                error={props.error && !props.validator.fieldValid(`cancer_#${i + 1}_site_of_cancer`)}
                                                helperText={props.validator.message(`cancer_#${i + 1}_site_of_cancer`, cancer.siteOfCancer, 'required')}
                                            />
                                        </Box>
                                        <Box className={classes.inputSection} display={cancer.siteOfCancer === 'Other' ? 'block' : 'none'}>
                                            {/* <Typography className={classes.subTitle}>Describe the other site of cancer?</Typography> */}
                                            <AppTextField
                                                label="Describe the other site of cancer"
                                                variant="outlined"
                                                fullWidth
                                                margin="normal"
                                                inputProps={{ style: { maxLength: 500, textAlign: 'center' } }}
                                                value={cancer.otherSiteOfCancer}
                                                onChange={e => props.onOtherCancerDiagnosisChange(e, 'otherSiteOfCancer', i)}
                                                error={props.error && !props.validator.fieldValid(`cancer_#${i + 1}_other_site_of_cancer`)}
                                                helperText={props.validator.message(`cancer_#${i + 1}_other_site_of_cancer`, cancer.otherSiteOfCancer, `other_site_of_cancer:${cancer.siteOfCancer}`)}
                                            />
                                        </Box>
                                        <Box className={classes.inputSection}>
                                            {/* <Typography className={classes.subTitle}>When did you affect by cancer?</Typography> */}
                                            <AppSelect
                                                id={`cancer${i + 1}`}
                                                label="Year"
                                                value={cancer.year}
                                                items={cancerYears}
                                                onChange={e => props.onCancerDiagnosisYearChange(e, i)}
                                                fullWidth
                                                error={props.error && !props.validator.fieldValid(`cancer_#${i + 1}_year`)}
                                                helperText={props.validator.message(`cancer_#${i + 1}_year`, cancer.year, 'required')}
                                            />
                                        </Box>
                                    </>
                                    <>
                                        <Typography variant="h5">Tell us about your cancer treatment taken.


                                        </Typography>
                                        {cancer.treatments.map((treatment, j) =>
                                            <Box className={classes.item} key={j}>
                                                <Box className={classes.innerItemHeader}>
                                                    <span>Treatment #{j + 1}</span>
                                                    <IconButton aria-label="delete" color="inherit" onClick={e => props.onTreatmentDelete(e, j, i)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Box>
                                                {/* Treatments of cancer diagnosis */}
                                                <Box className={classes.itemBody}>
                                                    <Box className={classes.inputSection}>
                                                        {/* <Typography className={classes.subTitle}>Select treatment type</Typography> */}
                                                        <AppSelect
                                                            id={`treatment${j + 1}`}
                                                            label="Treatment Type"
                                                            value={treatment.treatmentType}
                                                            items={['None', ...cancerTreatments, 'Other']}
                                                            onChange={e => props.onTreatmentPropertyChange(e, 'treatmentType', j, i)}
                                                            fullWidth
                                                            error={props.error && !props.validator.fieldValid(`cancer_#${i + 1}_treatment_#${j + 1}_treatment_type`)}
                                                            helperText={props.validator.message(`cancer_#${i + 1}_treatment_#${j + 1}_treatment_type`, treatment.treatmentType, 'required')}
                                                        />
                                                    </Box>
                                                    <Box className={classes.inputSection} display={treatment.treatmentType === 'Other' ? 'block' : 'none'}>
                                                        {/* <Typography className={classes.subTitle}>Describe the other cancer treatment taken.</Typography> */}
                                                        <AppTextField
                                                            label="Describe the other treatment type"
                                                            variant="outlined"
                                                            margin="normal"
                                                            fullWidth
                                                            inputProps={{ style: { maxLength: 500, textAlign: 'center' } }}
                                                            value={treatment.otherTreatmentType}
                                                            onChange={e => props.onTreatmentPropertyChange(e, 'otherTreatmentType', j, i)}
                                                            error={props.error && !props.validator.fieldValid(`cancer_#${i + 1}_treatment_#${j + 1}_other_treatment_type`)}
                                                            helperText={props.validator.message(`cancer_#${i + 1}_treatment_#${j + 1}_other_treatment_type`, treatment.otherTreatmentType, `other_treatment_type:${treatment.treatmentType}`)}
                                                        />
                                                    </Box>
                                                    <Box
                                                        className={classes.inputSection}
                                                        display={treatment.treatmentType === 'None' ? 'none' : 'block'}
                                                    >
                                                        <Typography variant="h5" >Period of treatment
                                                            {
                                                                <span className={((props.error && !props.validator.fieldValid(`#${i + 1}_cancer_#${j + 1}_treatment_treatmentfromyear`)) || (props.error && !props.validator.fieldValid(`#${i + 1}_cancer_#${j + 1}_treatment_treatmenttoyear`))) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                                                            }
                                                        </Typography>
                                                        <Grid container spacing={1}>
                                                            <Grid item xs={6}>
                                                                <AppSelect
                                                                    id={`treatmentFromYear${j + 1}`}
                                                                    label="From"
                                                                    value={treatment.treatmentFromYear}
                                                                    items={treatment.fromYears}
                                                                    onChange={e => props.onTreatmentPropertyChange(e, 'treatmentFromYear', j, i)}
                                                                    error={props.error && !props.validator.fieldValid(`#${i + 1}_cancer_#${j + 1}_treatment_treatmentfromyear`)}
                                                                    helperText={props.validator.message(`#${i + 1}_cancer_#${j + 1}_treatment_treatmentfromyear`, treatment.treatmentFromYear, `treatment_year:${treatment.treatmentType}`)}
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <AppSelect
                                                                    id={`treatmentToYear${j + 1}`}
                                                                    label="To"
                                                                    value={treatment.treatmentToYear}
                                                                    items={[...treatment.toYears, 'Current treatment']}
                                                                    onChange={e => props.onTreatmentPropertyChange(e, 'treatmentToYear', j, i)}
                                                                    error={props.error && !props.validator.fieldValid(`#${i + 1}_cancer_#${j + 1}_treatment_treatmenttoyear`)}
                                                                    helperText={props.validator.message(`#${i + 1}_cancer_#${j + 1}_treatment_treatmenttoyear`, treatment.treatmentToYear, `treatment_year:${treatment.treatmentType}`)}
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        )}
                                        <MobileButton
                                            className={classes.buttonStyle}
                                            onClick={e => props.onTreatmentAdd(e, i, [...cancer.treatments],
                                                {
                                                    treatmentType: '',
                                                    otherTreatmentType: '',
                                                    treatmentFromYear: '',
                                                    treatmentToYear: '',
                                                    fromYears: [...arrayOfNumbers((cancer.year), (currentYear - (cancer.year) + 1))],
                                                    toYears: [...arrayOfNumbers((cancer.year), (currentYear - (cancer.year) + 1))]
                                                })}
                                            color="primary"
                                            label="Add Treatment"
                                            endIcon={<AddIcon />}
                                        />
                                    </>
                                </Box>
                            </Box>

                        )
                        }
                    </>
                    <MobileButton
                        onClick={props.onCancerDiagnosisAndTreatmentsAdd}
                        color="primary"
                        label="Add Cancer Diagnosis & Treatment"
                        endIcon={<AddIcon />}
                    />
                </>
            }

        </Box>
    );
};

export default multiItemQuestion(
    CancerDiagnosis,
    {
        otherSiteOfCancer: '',
        siteOfCancer: '',
    });
